export const addMobileResizeListener = (callback, mobileBreakpoint = 750) => {
    const handleResize = () => {
        callback(window.innerWidth < mobileBreakpoint);
    };

    handleResize(); // initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
};
